module.exports = __webpack_public_path__ + "img/PR5.38360d00.png";